import React, { lazy, Suspense, useState, useEffect } from "react";
import './suggestions.css';
import useAuth from "../../hooks/useAuth";
import { useTranslation } from "react-i18next";
import TourismOffice from "./TourismOffice";
import axios from "../../api/axios";
import PdfUpload from "../dynamic/PdfUpload";
import Suggestions from "./Suggestions";
import SuggestionsEdit from "./SuggestionsEdit";
import CarouselSuggEdit from "./CarouselSuggEdit";

const CarouselSugg = lazy(() => import('./CarouselSugg'));

const WEBSITE_URL = '/pdf_url';
const title = 'suggestions';

export default function SuggestionsMain() {
  const { username, auth } = useAuth();
  const { t } = useTranslation();
  const [suggestionsUrl, setSuggestionsUrl] = useState(null);

  useEffect(() => {
    async function fetch() {
      await axios.get(`${WEBSITE_URL}`, {
        params: { username, title },
      }).then((res) => {
        setSuggestionsUrl(res.data);
      }).catch(function (error) {
        console.log(error);
      });
    }
    fetch();
  }, [username]);

  return (
    <div className="default">
      <Suspense fallback={<h1>Still Loading…</h1>}>
        {!auth?.role ? (
          <CarouselSugg
            title="suggestions"
            username={username}
            type="image-about"
          />
        ) : (
          <CarouselSuggEdit
            title="suggestions"
            username={username}
            type="image-about"
            maxImages={15}
          />
        )}
      </Suspense>

      <div className="stripe">
        <h1 style={{ marginTop: "-20px" }}>{t("suggestions_page.mainSuggestions")}</h1>
      </div>

      <TourismOffice suggestionsUrl={suggestionsUrl} />

      <div className="stripe ">
        <div className="container">
          <div>{!auth?.role ? <Suggestions /> : <SuggestionsEdit />}</div>
        </div>
      </div>

      {!auth?.role ? (
        <>
          {suggestionsUrl && (
            <div className="stripe-suggestions ">
              {/* <div className="suggestions-pdf-container">
                <FontAwesomeIcon icon={faLightbulb} />
                <a className="suggestions-text" href={suggestionsUrl}>
                  {t("suggestions_page.recommendations")}
                </a>
              </div> */}
            </div>
          )}
        </>
      ) : (
        <div className="stripe-suggestions ">
          <div className="suggestions-pdf-container">
            <div className="upload-label">
              {t("suggestions_page.upload-pdf")}
            </div>
            <PdfUpload username={username} title={title} />
          </div>
        </div>
      )}
    </div>
  );
}
